export function openUrl(url, target = '_self') {
  if (typeof window !== 'undefined') {
    window.open(url, target)
  }
}

/**
 * @param {string} url
 * @param {[{name: string, value: string}]} params
 * @param {URLSearchParams} urlParams
 * @returns {string}
 */
export const appendUrlParams = (url, params, urlParams = new URLSearchParams()) => {
  if (!params) return url

  for (const param of params) {
    setSearchUrlParam(param, urlParams)
  }
  return `${url}?${urlParams.toString()}`
}

/**
 * @param {{value: string|array|number, name: string}} param
 * @param {URLSearchParams} urlParams
 * @param {boolean} includeArrayString
 */
export const setSearchUrlParam = (param, urlParams, includeArrayString = false) => {
  if (Array.isArray(param.value)) {
    urlParams.append(param.name, `[${param.value}]`)
  } else if (includeArrayString && 'string' === typeof param.value && param.value.match(/^[\d,]+$/)) {
    urlParams.append(param.name, `[${param.value}]`)
  } else {
    urlParams.append(param.name, param.value)
  }
}

/**
 * @param {string} url
 * @param {{ [name: string]: string|number|null|undefined}} params
 * @returns {string}
 */
export const appendUrlParamsFromObject = (url, params) => {
  if (typeof params !== 'object') return url

  const mappedParams = Object.keys(params).map((name) => ({
    name,
    value: params[name],
  }))

  return appendUrlParams(url, mappedParams)
}

/**
 * Check if the url is valid
 * @param {string} url
 * @returns whether the url is valid
 */
export const isValidUrl = (url) => {
  try {
    new URL(url)
    return true
  } catch (e) {
    return false
  }
}

/**
 * Check if url has params
 * @param {*} url
 * @returns true or false depending on existence of url params
 */
export const hasParams = (url) => {
  const urlArray = url.split('?')
  return urlArray.length > 1 && urlArray[1] !== ''
}

/**
 * Given a pathname, remove the prefix "/pk/" from it
 * @param pathname - The pathname of the URL.
 * @returns The pathname without the prefix.
 */
export const getUnprefixedPathname = (pathname = '') => {
  let unprefixedPathname = pathname.replace(/^\/pk/g, '')
  if (unprefixedPathname === '') unprefixedPathname = '/'
  return unprefixedPathname
}
